import React from 'react';

import styles from "../../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";

export const AthleteWidgetIconPlaceholder = ({device, iconSize}) => {
  const {isSmallView} = device;

  const roundProps = {
    className: classNames(styles.round),
    style: {width: iconSize, height: iconSize},
  }

  return (
    <div className={classNames(styles.entity, {[styles.small_view]: isSmallView})}>
      <div {...roundProps}/>
      <div className={classNames(styles.value)}/>
      <div className={classNames(styles.label)}/>
    </div>
  )
}
